import { render, staticRenderFns } from "./BaseMailShare.vue?vue&type=template&id=56061670&"
import script from "./BaseMailShare.vue?vue&type=script&lang=js&"
export * from "./BaseMailShare.vue?vue&type=script&lang=js&"
import style0 from "./BaseMailShare.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports